"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkPrompt = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/text/semantics/paragraph");
require("@/components/common/link/link");
require("@/components/common/icon");
let LinkPrompt = class LinkPrompt extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.message = '';
        this.linkLabel = '';
        this.href = '';
        this.external = false;
    }
    render() {
        return (0, lit_1.html) `
      ${this.renderIcon()}
      <mm-paragraph>
        ${this.message}
        <mm-link href=${this.href} ?external=${this.external}>${this.linkLabel}</mm-link>
      </mm-paragraph>
    `;
    }
    renderIcon() {
        if (!this.icon)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-icon name=${this.icon} aria-hidden="true"></mm-icon>
    `;
    }
};
LinkPrompt.styles = (0, lit_1.css) `
    :host {
      display: inline-flex;
      flex-wrap: wrap;
      align-items: center;
      gap: var(--space-1);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], LinkPrompt.prototype, "icon", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], LinkPrompt.prototype, "message", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'link-label' })
], LinkPrompt.prototype, "linkLabel", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], LinkPrompt.prototype, "href", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], LinkPrompt.prototype, "external", void 0);
LinkPrompt = __decorate([
    (0, decorators_js_1.customElement)('mm-link-prompt')
], LinkPrompt);
exports.LinkPrompt = LinkPrompt;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGluay1wcm9tcHQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJsaW5rLXByb21wdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBb0Q7QUFDcEQscURBQTJEO0FBRzNELHdEQUFxRDtBQUNyRCx5Q0FBc0M7QUFDdEMsb0NBQWlDO0FBRzFCLElBQU0sVUFBVSxHQUFoQixNQUFNLFVBQVcsU0FBUSxnQkFBVTtJQUFuQzs7UUFVdUIsWUFBTyxHQUFHLEVBQUUsQ0FBQTtRQUNhLGNBQVMsR0FBRyxFQUFFLENBQUE7UUFDdkMsU0FBSSxHQUFHLEVBQUUsQ0FBQTtRQUNSLGFBQVEsR0FBRyxLQUFLLENBQUE7SUFtQi9DLENBQUM7SUFqQkMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7UUFDUCxJQUFJLENBQUMsVUFBVSxFQUFFOztVQUVmLElBQUksQ0FBQyxPQUFPO3dCQUNFLElBQUksQ0FBQyxJQUFJLGNBQWMsSUFBSSxDQUFDLFFBQVEsSUFBSSxJQUFJLENBQUMsU0FBUzs7S0FFekUsQ0FBQTtJQUNILENBQUM7SUFFTyxVQUFVO1FBQ2hCLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSTtZQUFFLE9BQU8sYUFBTyxDQUFBO1FBRTlCLE9BQU8sSUFBQSxVQUFJLEVBQUE7c0JBQ08sSUFBSSxDQUFDLElBQUk7S0FDMUIsQ0FBQTtJQUNILENBQUM7O0FBOUJNLGlCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7R0FPbEIsQ0FBQTtBQUMyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7d0NBQWdCO0FBQ2Y7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzJDQUFhO0FBQ2E7SUFBcEQsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxTQUFTLEVBQUUsWUFBWSxFQUFFLENBQUM7NkNBQWU7QUFDdkM7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3dDQUFVO0FBQ1I7SUFBNUIsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxDQUFDOzRDQUFpQjtBQWJsQyxVQUFVO0lBRHRCLElBQUEsNkJBQWEsRUFBQyxnQkFBZ0IsQ0FBQztHQUNuQixVQUFVLENBZ0N0QjtBQWhDWSxnQ0FBVSJ9